'use client';

import { useEffect, useState } from 'react';
import { DMImage } from '@/components/custom-image/custom-image';
import { DMLink } from '@/components/link';
import { SkeletonLoader } from '@/components/skeleton-loader';
import { ALL_BADGE } from '@/lib/utils';
import { DialogClose } from '@radix-ui/react-dialog';
import { getAllLevelData } from '../action';

// const badge = [
//   {
//     id: '1',
//     name: 'Iron',
//     icon: ironBadge,
//     level: 1,
//   },
//   {
//     id: '2',
//     name: 'Bronze',
//     icon: bronzeBadge,
//     level: 2,
//   },
//   {
//     id: '3',
//     name: 'Silver',
//     icon: silverBadge,
//     level: 3,
//   },
//   {
//     id: '4',
//     name: 'Gold',
//     icon: goldBadge,
//     level: 4,
//   },
//   {
//     id: '5',
//     name: 'Platinum',
//     icon: platinumBadge,
//     level: 5,
//   },
//   {
//     id: '6',
//     name: 'Diamond',
//     icon: diamondBadge,
//     level: 6,
//   },
//   {
//     id: '7',
//     name: 'Legendary',
//     icon: legendaryBadge,
//     level: 7,
//   },
// ];

function LevelBadges({ hideHeader = false }: { hideHeader?: boolean }) {
  const [badges, setBadges] = useState<any>([]);

  useEffect(() => {
    getLevelData();
  }, []);

  const getLevelData = async () => {
    try {
      const response = await getAllLevelData();

      const updated = response?.map(item => {
        const matchingBadge = ALL_BADGE?.find(b => b?.level === item?.level);
        return {
          ...item,
          icon: matchingBadge ? matchingBadge.icon : null,
        };
      });

      setBadges(updated);
    } catch (error) {
      console.error('Error fetching level data:', error);
      throw error;
    }
  };

  return (
    <div className='relative flex flex-col items-start justify-start self-start w-full px-4 sm:px-14 gap-2 mt-6 flex-1 h-full overflow-hidden'>
      {hideHeader && (
        <p className='pl-1 flex gap-1 text-sm'>
          How does it work?
          <DMLink href='/level-up' className='underline text-brand-silver'>
            <DialogClose>Learn More</DialogClose>
          </DMLink>
        </p>
      )}
      <div className='mb-10 overflow-y-auto w-full pr-1'>
        <div className='grid grid-cols-2 lg:grid-cols-3 gap-1 md:gap-2 grid-flow-row w-full'>
          {badges.length > 0 ? (
            badges?.map((badge: any, index: number) => (
              <BadgeCard
                key={index}
                id={badge.id}
                name={badge.name}
                icon={badge.icon}
                point={badge.startPoint}
              />
            ))
          ) : (
            <SkeletonLoader count={3} />
          )}
        </div>
      </div>
    </div>
  );
}

export default LevelBadges;

type badgeCardProps = {
  id: string;
  name: string;
  icon: string;
  point: number;
};
const BadgeCard = ({ name, icon, point }: badgeCardProps) => {
  return (
    <div className='flex bg-brand-third p-3 border-brand-primary-border border rounded-md gap-3 items-center h-12'>
      <DMImage src={icon} alt='Notification Badge' width={24} height={24} />
      <p className='flex-1 font-bold text-sm text-brand-silver text-left'>{name}</p>
      <p className='font-bold text-sm'>{point}</p>
    </div>
  );
};
